import { render, staticRenderFns } from "./SoalFinish.vue?vue&type=template&id=242dc75f&scoped=true"
import script from "./SoalFinish.vue?vue&type=script&lang=js"
export * from "./SoalFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242dc75f",
  null
  
)

export default component.exports